const messages = {
  TIPO_ERROR: 'error',
  TIPO_INFO: 'info',
  TIPO_SUCCESS: 'success',
  TIPO_WARNING: 'warning',
  TITULO_ERROR: 'Erro',
  TITULO_NOVOS_PROCESSOS: 'Processos atualizados',
  TITULO_FINISH: 'Finalizar',
  TITULO_SUCCESS: 'Sucesso',
  TITULO_WARNING: 'Atenção',
  ERROR_MESSAGE: 'Ocorreu um erro inesperado, tente novamente mais tarde.',
  UNAUTHORIZED:
    'Usuário não possui permissão para realizar a ação. Por favor efetue o login novamente.',
  ERRO_USUARIO_JA_CADASTRADO: 'O usuário já está cadastrado.',
  PREENCHA_TODOS_CAMPOS: 'Preencha todos os campos destacados corretamente.',
  USUARIO_CADASTRADO_SUCESSO: 'O usuário foi cadastrado com sucesso.',
  ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS:
    'Preencha os campos obrigatórios para prosseguir.',
  ALTERACAO_SUCESSO: 'Alteração realizada com sucesso',
  ERRO_CADASTRO_USUARIO:
    'Ocorreu um erro ao cadastrar o usuário, tente novamente mais tarde.',
  MINIMO_CARACTERES: 'No mínimo 6 caracteres',
  DIGITE_A_SENHA: 'Digite a senha',
  SENHAS_INCOMPATIVEIS: 'As senhas informadas devem ser iguais',
  CPF_VALIDO: 'É necessário inserir um CPF válido',
  CNPJ_VALIDO: 'É necessário inserir um CNPJ válido',
  DOCUMENTO_VALIDO: 'É necessário inserir um Documento válido',
  NOME_OBRIGATORIO: 'Nome é obrigatório',
  RAZAO_SOCIAL_OBRIGATORIA: 'Razão social é obrigatória',
  EMAIL_VALIDO: 'É necessário inserir um e-mail válido',
  EMAILS_DIFERENTES: 'Os e-mails informados devem ser iguais',
  NECESSARIO_UM_PERFIL: 'É necessário inserir pelo menos um perfil.',
  PERFIS_MESMO_SETOR: 'Não é possível inserir dois perfis de um mesmo setor.',
  PERFIS_EXTERNOS_E_INTERNOS:
    'Um usuário não poderá ter perfil interno e externo.',
  ALTERAR_TIPO_USUARIO_PERFIL_INTERNO:
    'Não é possível alterar o tipo de usuário pois este possui perfil interno.',
  SENHA_ALTERADA_SUCESSO: 'Sua senha foi atualizada com sucesso.',
  MSG_REDEFINIR_SENHA:
    'Um link para redefinição de senha foi enviado para seu e-mail.',
  REDEFINIR_SENHA_WARNING:
    'Um e-mail de redefinição de senha será enviado ao usuário, deseja confirmar esta ação?',
  ALTERAR_TIPO_USUARIO_WARNING:
    'Ao alterar o tipo de pessoa você perderá os dados preenchidos. Deseja confirmar esta ação?',
  SOLICITACAO_REDEFINICAO_SENHA_SUCESSO:
    'A solicitação de redefinição de senha foi feita com sucesso.',
  CAMPO_OBRIGATORIO: 'Campo Obrigatório.',
  MSG_CANCELAR_CADASTRO:
    'Ao cancelar o cadastro, todos os dados preenchidos serão perdidos. Deseja confirmar esta ação?',
  MSG_FINALIZAR_CADASTRO:
    'Ao finalizar o cadastro, será enviado para o e-mail cadastrado um link para ativação do cadastro e definição da senha. Deseja confirmar esta ação?',
  MAX_LENGTH: 'Campo deve conter no máximo %S caractéres.',
  ARQUIVO_EXTENSION_FAIL: 'Extensão de arquivo não pode ser diferente de: $$',
  ARQUIVO_SIZE_FAIL: 'Arquivo deve ter no máximo $$MB de tamanho!',
  DOCUMENTO_REMOVE_CONFIRM: 'Tem certeza que deseja remover o documento?',
  USUARIO_BLOQUEADO_SUCESSO: 'Usuário bloqueado com sucesso.',
  USUARIO_DESBLOQUEADO_SUCESSO: 'Usuário desbloqueado com sucesso.',
  DESBLOQUEIO_USUARIO_WARNING:
    'Não é possível desbloquear este usuário, primeiro acesso não foi realizado!',
  ALTERAR_PROPRIO_PERFIL:
    'Você está alterando seu proprio perfil e será deslogado ao continuar, tem certeza?',
  ALTEROU_MESMO_PERFIL: 'Não é possível cadastrar e excluir o mesmo perfil.',
  NENHUMA_ALTERACAO_PERFIL: 'Não houve nenhuma alteração no perfil.',
  SELECIONAR_PERFIL: 'O usuário deverá ter pelo menos um perfil vinculado.',
};

export default messages;
